import React from 'react';
import './styles.scss';

const PageContent: React.FC<any> = ({className = '', withTopPadding, withBottomMargin, ...props}) => {
  className += ' page-content';

  if (withTopPadding) {
    className += ' with-top-padding';
  }

  if (withBottomMargin) {
    className += ' with-bottom-margin';
  }

  return (
    <div className={className} {...props} />
  )
}

export default PageContent;
